import { render } from "./PopUpQuestion.vue?vue&type=template&id=24c24ef9"
import script from "./PopUpQuestion.vue?vue&type=script&lang=js"
export * from "./PopUpQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__